import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Sheet, SheetRef } from 'react-modal-sheet';
import { useDispatch, useSelector } from 'react-redux';
import { MapMode } from '../../types';
import CompoundDrawer from '../compound/CompoundDrawer';
import { useRouter } from 'next/router';
import {
  setSelectedCompound,
  setMapMode,
  setDrawerPosition
} from '../../../../redux/slices/mapSlice';

const MDrawer = () => {
  const { locale } = useRouter();

  const dispatch = useDispatch();

  const mapMode = useSelector((state: any) => state.map.mapMode);

  const drawerSnapPoints = [1, 0.39, 0];
  const sheetRef = useRef<SheetRef>();

  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);

  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );

  const [snapPoint, setSnapPoint] = useState(1);

  const renderDrawer = useCallback(() => {
    if (mapMode === MapMode.COMPOUND && selectedCompound) {
      return snapPoint === 0 ? (
        <Sheet.Scroller
          draggableAt="both"
          style={{
            position: 'relative',
            gap: '16px',
            direction: locale === 'ar' ? 'rtl' : 'ltr'
          }}
          className="hide-scrollbar"
          draggable
        >
          <CompoundDrawer snapPoint={snapPoint} />
        </Sheet.Scroller>
      ) : (
        <CompoundDrawer snapPoint={snapPoint} />
      );
    }
  }, [mapMode, snapPoint]);

  const handleCloseDrawer = () => {
    dispatch(setSelectedCompound(null));
    dispatch(setMapMode(MapMode.SEARCH));
    setSnapPoint(0);
    dispatch(setDrawerPosition(37));
  };

  const spring = {
    type: 'spring',
    damping: 10,
    stiffness: 100
  };

  const handleSnap = (index: number) => {
    if (!initialSnap) {
      dispatch(setDrawerPosition(40));
    } else {
      setInitialSnap(false);
    }
    setSnapPoint(index);
  };

  const [initialSnap, setInitialSnap] = useState(true);

  return mapMode === MapMode.COMPOUND ? (
    <Sheet
      ref={sheetRef}
      isOpen={drawerOpen}
      onClose={handleCloseDrawer}
      snapPoints={drawerSnapPoints}
      initialSnap={1}
      onSnap={index => handleSnap(index)}
      animate
      transition={spring}
      prefersReducedMotion
    >
      <Sheet.Container
        style={{
          padding: '8px 16px 16px 16px'
        }}
      >
        <Sheet.Header />

        <Sheet.Content
          style={{
            width: '100%',
            direction: locale == 'ar' ? 'rtl' : 'ltr'
          }}
          disableDrag={snapPoint === 0 && selectedCompound}
        >
          {renderDrawer()}
        </Sheet.Content>
      </Sheet.Container>
    </Sheet>
  ) : null;
};

export default MDrawer;
